export function isSocketDevice(device) {
    return (device.device_type?.code === 'SOCKETS_03' ||
        device.hardware_type?.code === '721');
}
